import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CommunicationConstants } from 'src/app/core/constants/communication';
import { IResult } from 'src/app/core/interfaces/result';
import { environment } from 'src/environments/environment';
import {IRequest, IResponse} from "./bank-dialog.model";


const API_MAIN = environment.security + environment.host + environment.version + environment.typeService;

@Injectable()
export class BankDialogService {

  private URL : string = API_MAIN + "bank-api/get-all";

	constructor(private _http: HttpClient){}

	getPaginated(request : IResponse) : Observable<any>{

		return this._http
      .post<IResult<IRequest>>(this.URL, request)
      .pipe(
        map((res: IResult<IRequest>) => {
          const [codigosCom, mensajesCom] = CommunicationConstants;
          if (res === null){
              throw new Error(`${codigosCom.ERRORSRV}||${mensajesCom.MSGDATAVACIOSRV}`);
          }
          return res.Data;
        })
      );
	}


}
